import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { LoginComponent } from '../login/login.component';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from 'src/app/services/states.service';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() delegationToken: string;
  @Input() essai_gratuit : any = false;

  user:any = '';
  isHomepage = false;

  constructor(
    public dialog: MatDialog,
    public activatedRoute: ActivatedRoute,
    public stateService: StateService,
    public appService : AppService,
    public router: Router,
    private cookies: CookieService
    ) { }

  ngOnInit() {
    this.stateService.user.subscribe((user)=> {
        this.user = user;
    });
    if (this.router.url === "/homepage") {
        this.isHomepage = true;
    } else {
        this.isHomepage = false;
    }
  }

    ngOnChanges() {
        if (this.router.url === "/homepage") {
            this.isHomepage = true;
        } else {
            this.isHomepage = false;
        }
    }

  
  openLogin() {
    this.router.navigateByUrl("/");
    // let dialogRef = this.dialog.open(LoginComponent, {      
    //     height: "55%",
    //     width: "max(20rem, 25%)",
    //     panelClass:'dialog-login'
    // })
  }

  logout(){
    this.appService.logout().subscribe(() => {
        location.reload();
/*
      this.stateService.updateUser(null);
      this.cookies.set("Tokenauth", "");
      this.router.navigateByUrl("/homepage");
*/
    });
  }

  goDossier(state = 1){
console.log('STEP 1')
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> {
        console.log('STEP 2')
        this.router.navigate(['/dossier' + (state == 2 ? '/archive' : '')]);
    })
  }
  // refreshIfDossier(){
  //   if (this.router.url.startsWith("/dossier")) {
  //     window.location.reload();     
  //   }
  // }
}
